module.exports = __webpack_public_path__ + "img/case_summary_thumb.c88655ff.png";